import LabeledHOC from '@platform/react/hoc/list/labeled'
import CellHOC from '@platform/react/hoc/list/cell'
import { ListItemCellNameOrCount, styles } from 'ui/Element/List/Item/Cell/Ticket/NameOrCount'

export default CellHOC(
  LabeledHOC(
    props => props.labels.plural, ListItemCellNameOrCount,
  ), styles,
)
